/* eslint-disable @next/next/no-img-element */
import React from 'react';

const logos = [
  {
    src: '/partner-logos/logo-yc.svg',
    alt: 'ptnr',
    maxWidth: '50px',
    maxHeight: '50px'
  },
  {
    src: '/partner-logos/logo-spc.svg',
    alt: 'ptnr',
    maxWidth: '50px',
    maxHeight: '50px'
  },
  {
    src: '/partner-logos/logo-ondeck.svg',
    alt: 'ptnr',
    maxWidth: '100px',
    maxHeight: '50px'
  },
  {
    src: '/partner-logos/logo-techstars.svg',
    alt: 'ptnr',
    maxWidth: '100px',
    maxHeight: '50px'
  },
  {
    src: '/partner-logos/logo-heavybit.svg',
    alt: 'ptnr',
    maxWidth: '50px',
    maxHeight: '50px'
  },
  {
    src: '/partner-logos/logo-l2ventures.svg',
    alt: 'ptnr',
    maxWidth: '50px',
    maxHeight: '50px'
  },
  {
    src: '/partner-logos/logo-haystack.svg',
    alt: 'ptnr',
    maxWidth: '50px',
    maxHeight: '50px'
  },
  {
    src: '/partner-logos/logo-pioneer.svg',
    alt: 'ptnr',
    maxWidth: '100px',
    maxHeight: '50px'
  },
  {
    src: '/partner-logos/logo-lh.svg',
    alt: 'ptnr',
    maxWidth: '50px',
    maxHeight: '50px'
  },
  {
    src: '/partner-logos/logo-seedcamp.svg',
    alt: 'sc',
    maxWidth: '280px',
    maxHeight: '50px'
  }
];
type TProps = {
  className?: string;
};

export const PartnersLogoCloud: React.FC<TProps> = props => {
  const { className } = props;
  return (
    <section className={className}>
      <div className="max-w-2xl px-4 py-16 mx-auto lg:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
        <h2 className="text-sm font-bold text-center text-gray-600">
          OUR PARTNERS
        </h2>
        <div className="flex flex-wrap overflow-hidden lg:px-20">
          {logos.map(({ src, alt, maxWidth, maxHeight }) => (
            <div key={src} className="flex justify-center w-1/2 mt-20 md:w-1/5">
              <img style={{ maxWidth, maxHeight }} src={src} alt={alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
